import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useStatContext } from "../contexts/ContextProvider";

const PrivateRoute = () => {
  const { token } = useStatContext();
  if (!token) return <Navigate to="/login" />;
  return <Outlet />;
};

export default PrivateRoute;
